import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import reservationRemarkActions from 'actions/reservation_remark.actions';
import { connect } from 'react-redux';

//import avatar from "assets/img/faces/face-3.jpg";

class AddReservationRemark extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      reservation_remark: {
        note: '',
        user: this.props.me.id,
        reservation: this.props.match.params.reservation
      },
      suggestions: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    let reservation_remark = this.state.reservation_remark;
    reservation_remark[name] = value;
    this.setState({ reservation_remark: reservation_remark });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { dispatch } = this.props;
    if (this.state.reservation_remark.user && this.state.reservation_remark.note && this.state.reservation_remark.reservation) {
      dispatch(
        reservationRemarkActions.add(
          {
            user: this.state.reservation_remark.user,
            note: this.state.reservation_remark.note,
            reservation: this.state.reservation_remark.reservation
          }
        )
      );
    }
  }

  componentWillUpdate(props) {
    if(props.error && !this.props.error) {
      this.props.addNotification({type: 'error', message: props.error});
    }
    if(props.success && !this.props.success) {
      this.props.addNotification({type: 'success', message: 'Reservation Remark Added successfully'});
      this.setState({
        reservation_remark: {
          user: this.props.me.id,
          note: ''
        },  
        submitted: false
      });
    }
  }

  render() {
    const { submitted, reservation_remark } = this.state;
    const { loading } = this.props;
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Add Reservation Remark"
                content={
                  <form name="profileForm" onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>Reservation</ControlLabel>
                          <FormControl placeholder="Reservation" disabled={true} bsClass= "form-control" name="reservation" value={reservation_remark.reservation} onChange={this.handleChange}></FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="error-row">
                      <Col md={6}>{submitted && !reservation_remark.user && <div className="error">User is required</div>}</Col>
                      <Col md={6}>{submitted && !reservation_remark.reservation && <div className="error">Reservation is required</div>}</Col>
                    </Row>
                    <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          label: "Remark",
                          componentClass: "textarea",
                          bsClass: "form-control",
                          placeholder: "Remark",
                          value: reservation_remark.note,
                          name: 'note',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={12}>{submitted && !reservation_remark.note && <div className="error">Remark is required</div>}</Col>
                    </Row>
                    <Button bsStyle="info" disabled={loading} fill type="submit">
                      Add Reservation Remark
                    </Button>
                    {loading && submitted && 
                      <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loading, item, error, success } = state.reservationRemarks;
  return {
    loading, reservation_remark: item, error, success, me: state.authentication.me
  };
}
 
export default connect(mapStateToProps)(AddReservationRemark);
